var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35288 8.52977C9.69951 8.52977 11.6178 6.61152 11.6178 4.26488C11.6178 1.91826 9.69951 0 7.35288 0C5.00625 0 3.08803 1.91826 3.08803 4.26488C3.08803 6.61152 5.00629 8.52977 7.35288 8.52977ZM14.6721 11.9379C14.5604 11.6586 14.4114 11.3978 14.2438 11.1557C13.3871 9.88929 12.0648 9.05122 10.5749 8.84635C10.3886 8.82775 10.1838 8.86496 10.0348 8.97672C9.25257 9.55406 8.32139 9.85204 7.35292 9.85204C6.38445 9.85204 5.45327 9.55406 4.67106 8.97672C4.52206 8.86496 4.31719 8.8091 4.13097 8.84635C2.64105 9.05122 1.30014 9.88929 0.462071 11.1557C0.294457 11.3978 0.145451 11.6772 0.0337322 11.9379C-0.0221272 12.0497 -0.0035193 12.1801 0.0523401 12.2918C0.201346 12.5525 0.387568 12.8133 0.555182 13.0368C0.815906 13.3906 1.09527 13.7072 1.41189 14.0052C1.67262 14.2659 1.9706 14.508 2.26861 14.7502C3.73988 15.849 5.50917 16.4263 7.33431 16.4263C9.15946 16.4263 10.9287 15.849 12.4 14.7502C12.698 14.5267 12.996 14.2659 13.2567 14.0052C13.5547 13.7072 13.8527 13.3906 14.1134 13.0368C14.2997 12.7947 14.4673 12.5525 14.6163 12.2918C14.7094 12.1801 14.728 12.0497 14.6721 11.9379Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2861bed6512cc473ddeb4bd25807d761.svg";
export { ForwardRef as ReactComponent };